var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-content"},[_c('div',{staticClass:"head"},[(_vm.jinNangDetail)?_c('author-jin-nang-statistic',{attrs:{"detail":_vm.jinNangDetail}}):_vm._e()],1),_c('div',{staticClass:"body"},[_c('div',{staticClass:"left"},[_c('jin-nang-tabs')],1),_c('div',{staticClass:"right"},[_c('router-view')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }